/**
 * Wagtail API image shapes: legacy (single url) and optimised (sources + fallback for picture/srcset).
 */

export interface SrcSetEntry {
  url: string;
  w: number;
}

export interface ImageSource {
  media_type: string;
  src_set: SrcSetEntry[];
}

export interface ImageFallback {
  url: string;
  src_set: SrcSetEntry[];
}

/** Optimised image from API (multi-format, multi-size). */
export interface OptimisedImage {
  id?: number;
  title?: string;
  sources?: ImageSource[];
  fallback?: ImageFallback;
}

/** Legacy image from API (single URL). */
export interface LegacyImage {
  url?: string;
  title?: string;
}

/** Image from API: either optimised (sources + fallback) or legacy (url only). */
export type ApiImage = (OptimisedImage & LegacyImage) | null;

export function isOptimisedImage(image: ApiImage): image is OptimisedImage {
  return (
    image != null &&
    Array.isArray((image as OptimisedImage).sources) &&
    (image as OptimisedImage).fallback != null
  );
}

/** True when ApiResponsiveImage can render this payload (optimised or legacy URL). */
export function hasRenderableApiImage(image: ApiImage | null | undefined): boolean {
  if (image == null) return false;
  if (isOptimisedImage(image)) return true;
  const url = (image as LegacyImage).url;
  return typeof url === 'string' && url.length > 0;
}

/** Format src_set array as HTML srcset string (e.g. "url1 400w, url2 800w"). */
export function buildSrcSet(srcSet: SrcSetEntry[]): string {
  return srcSet.map(({ url, w }) => `${url} ${w}w`).join(', ');
}
